import Core                from "@/core/Core";
import PartnerCategoriesDAO from "@/domains/PartnerCategories/PartnerCategoriesDAO";
import PartnerCategory      from "@/domains/PartnerCategories/PartnerCategory";
import Dictionary           from "@/core/types/Dictionary";

class PartnerCategoriesService {

	/**
	 * Кеш категорий партнёров. Наполняется из Dictionaries общим эндпоинтом.
	 * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
	 */
	static partnerCategories = reactive(new Dictionary<string, PartnerCategory>());

	/**
	 * Загрузить список категорий партнёров
	 */
	static async getList(): Promise<PartnerCategory[]> {
		const response = await PartnerCategoriesDAO.getList();

		return Core.utils.hydrateArray(response.data, PartnerCategory.fromServer);
	}
}

export default PartnerCategoriesService;